import { render, staticRenderFns } from "./withdrawalManagementPage.vue?vue&type=template&id=18e74038&scoped=true"
import script from "./withdrawalManagementPage.vue?vue&type=script&lang=js"
export * from "./withdrawalManagementPage.vue?vue&type=script&lang=js"
import style0 from "./withdrawalManagementPage.vue?vue&type=style&index=0&id=18e74038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e74038",
  null
  
)

export default component.exports